import React, { useState } from 'react';
import InterviewScheduleDetails from './InterviewDetails';
import AdditionalInfoForm from './AdditionalInfoForm';
import UnAvailableReasons from './UnavailableReasons';
import '../../../css/Form.css';
import ApiGateway from '../../../helper/ApiGateway';
import ERPUtils from '../../../helper/Utils';
import useStateCallback from '../../../helper/asyncSetState';
import Loader from '../../../helper/Loader';
import Popup from '../../../helper/SuccessPopup';
import { toast } from 'react-toastify';

const SecondRound = (props) => {
	const { interviewDetails, ActiveInterviewRound, closeInterviewModal, getApplicationsData, savedData, ApplicationsPrevData } = props;
	//Loader:
	const [LoaderActive, setLoaderActive] = useStateCallback(false);
	// Popup state;
	const [showAlert, setShowAlert] = useStateCallback(false);
	// const [warningMsg, setWarmingMsg] = useState(false);
	const [requiredFieldsAlert, showRequiredFieldsAlert] = useState(false);
	const [ApiError, setApiError] = useState(false);
	// Component State:
	const [RenderData, setRenderData] = useStateCallback(null); // ResearchDetails Data
	const [ReasonsForRej, setReasonsForRej] = useStateCallback([]); // DropDown Data
	const [roundData, setRoundData] = useStateCallback({
		availableForInt: ERPUtils.isUndefinedOrNull(savedData) === false ? savedData.isAvailableForTheInterview : '',
		ResearchDetailsData:
			ERPUtils.isUndefinedOrNull(savedData) === false
				? ERPUtils.isUndefinedOrNull(savedData.researchDetailDTO) === false
					? ERPUtils.isUndefinedOrNull(savedData.researchDetailDTO.researchEntries) === false
						? ERPUtils.isUndefinedOrNull(
							savedData.researchDetailDTO.researchEntries.researchEntriesHeadings
						) === false
							? AssignSavedResearchData(savedData.researchDetailDTO.researchEntries.researchEntriesHeadings)
							: {}
						: {}
					: {}
				: {},

		HaveUanNo:
			ERPUtils.isUndefinedOrNull(savedData) === false
				? ERPUtils.isUndefinedOrNull(savedData.empApplnPersonalDataDTO) === false
					? savedData.empApplnPersonalDataDTO.isUanNo
					: ''
				: '',
		UanNo:
			ERPUtils.isUndefinedOrNull(savedData) === false
				? ERPUtils.isUndefinedOrNull(savedData.empApplnPersonalDataDTO) === false
					? savedData.empApplnPersonalDataDTO.uanNo
					: ''
				: '',
		RejectionReason: '',
		otherReason: ''
	});
	const [RequiedFields, setRequiredFields] = useStateCallback({
		availableForIntReqError: false,
		RejectionReasonReqError: false,
		otherReasonReqError: false
	});

	// Handlers:
	function AssignSavedResearchData(responseData) {
		let arrayObj = {};
		responseData?.map((el) => {
			const modify = { ...arrayObj[el.groupHeading] };
			el.parameters?.map((item) => {
				modify[item.researchParameter] = item.parameterValue;
				//empApplnAddtnlInfoEntriesId set
				modify[item.empApplnAddtnlInfoEntriesId] = item.empApplnAddtnlInfoEntriesId;
				arrayObj[el.groupHeading] = modify;
				return '';
			});
			return '';
		});
		return arrayObj;
	}

	// Handlers:
	const onChangeHandler = (event) => {
		const name = event.target.name;
		const val = event.target.value;
		let oldObj = { ...roundData };
		if (name === 'availableForInt') {
			if (val === 'true') {
				oldObj[name] = val;
				oldObj['RejectionReason'] = '';
				setRoundData(oldObj, () => {
					if (isShowInterviewDetails()) {
						callAdditionalDataApi()
					}
					changeRequiredStatus('availableForInt');
				});
			} else if (val === 'false') {
				oldObj[name] = val;
				// oldObj['ResearchDetailsData'] = {};
				setRenderData(null);
				setRoundData(oldObj, () => {
					ReasonsApi();
					changeRequiredStatus('availableForInt');
				});
			}
		} else {
			oldObj[name] = val;
			setRoundData(oldObj);
			changeRequiredStatus(name);
		}
	};

	const ResearchDetailsHandler = (event) => {
		const name = event.target.name;
		const val = event.target.value;
		const ObjName = event.target.title;
		let arrayObj = { ...roundData.ResearchDetailsData };
		const modify = { ...arrayObj[ObjName] };
		modify[name] = val;
		arrayObj[ObjName] = modify;
		setRoundData({
			...roundData,
			ResearchDetailsData: arrayObj
		});
	};

	const selectHandler = (selected) => {
		const oldObj = { ...roundData };
		oldObj['RejectionReason'] = selected;
		oldObj['otherReason'] = '';
		setRoundData(oldObj);
		changeRequiredStatus('RejectionReason');
		if (selected.isReschedulable === true) {
			setShowAlert(true);
		}
	};

	const changeRequiredStatus = (target) => {
		const oldObj = { ...RequiedFields };
		if (target === 'availableForInt') {
			oldObj['availableForIntReqError'] = false;
			oldObj['RejectionReasonReqError'] = false;
			oldObj['otherReasonReqError'] = false;
		}
		if (target === 'RejectionReason') {
			oldObj['RejectionReasonReqError'] = false;
			oldObj['otherReasonReqError'] = false;
		}
		if (target === 'otherReason') {
			oldObj['otherReasonReqError'] = false;
		}
		setRequiredFields(oldObj);
	};

	const CheckRequiredErrors = () => {
		const checkThese = ['availableForInt'];
		const ReqErrors = { ...RequiedFields };
		const available = {
			RejectionReason:
				roundData.availableForInt !== '' ? (roundData.availableForInt === 'false' ? true : false) : false,
			otherReason:
				roundData.RejectionReason !== '' ? (roundData.RejectionReason.label === 'Other' ? true : false) : false
		};

		checkThese.map((el) => {
			if (
				ERPUtils.isUndefinedOrNull(roundData[el]) === true ||
				ERPUtils.isNullOrEmpty(roundData[el]) === true ||
				ERPUtils.isNullorWhiteSpace(roundData[el]) === true
			) {
				let name = el + 'ReqError';
				ReqErrors[name] = true;
			} else {
				let name = el + 'ReqError';
				ReqErrors[name] = false;
			}
			return ''
		});

		Object.keys(available).map((el) => {
			if (available[el]) {
				if (
					ERPUtils.isUndefinedOrNull(roundData[el]) === true ||
					ERPUtils.isNullOrEmpty(roundData[el]) === true ||
					ERPUtils.isNullorWhiteSpace(roundData[el]) === true
				) {
					let name = el + 'ReqError';
					ReqErrors[name] = true;
				} else {
					let name = el + 'ReqError';
					ReqErrors[name] = false;
				}
			} else {
				let name = el + 'ReqError';
				ReqErrors[name] = false;
			}
			return ''
		});
		setRequiredFields(ReqErrors, () => {
			checkForErrors(ReqErrors);
		});
	};

	const checkForErrors = (data) => {
		var allVals = [];
		Object.keys(data).map((el) => {
			allVals.push(data[el]);
			return '';
		});
		if (allVals.indexOf(true) !== -1) {
			RequiredFieldsAlert();
		} else {
			submitData();
		}
		return '';
	};

	// To show required fields error popup
	const RequiredFieldsAlert = () => {
		showRequiredFieldsAlert(!requiredFieldsAlert);
	};
	// Reschedule popup
	const hideAlert = () => {
		setShowAlert(false);
	};

	// To Close the error popup
	const closeErrorPopup = () => {
		setApiError(false);
	};

	// Rejection popup
	// const warningHanlder = () => {
	// 	setWarmingMsg(false);
	// };

	// Api handlers:
	const callAdditionalDataApi = () => {
		setLoaderActive(true);
		let url = 'Employee/CommonEmployee/getResearchDetails';
		ApiGateway.post(url, {}, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							setRenderData(response.data.dto);
						} else {
							setLoaderActive(false);
							setApiError(true);
						}
					} catch (ex) { }
				}
			} catch (ex) {
				setLoaderActive(false);
				setApiError(true);
			}
		});
	};

	// Api handlers:
	const ReasonsApi = () => {
		setLoaderActive(true);
		let url = 'Employee/CommonEmployee/getApplnNonAvailability?interviewRound=';
		let interviewRound =
			ERPUtils.isUndefinedOrNull(ActiveInterviewRound.interviewRound) === false
				? ActiveInterviewRound.interviewRound
				: '';
		ApiGateway.post(url + interviewRound, {}, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							let newArray = []
							let otherObj = { value: 'Other', label: 'Other' }
							newArray = !ERPUtils.isUndefinedOrNull(response?.data?.dto) ? response?.data?.dto : []
							newArray.push(otherObj)
							setReasonsForRej(newArray);
							setLoaderActive(false);
						}
						else {
							setLoaderActive(false);
						}
					} catch (ex) { setLoaderActive(false); }
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	const savedAddnlInfoEntries = (ID) => {
		let data = null;
		const resEntriesdata = savedData.researchDetailDTO.researchEntries.researchEntriesHeadings;
		for (let item = 0; item < resEntriesdata?.length; item++) {
			const element = resEntriesdata[item].parameters;
			for (let para = 0; para < element?.length; para++) {
				const result = element[para].id;
				if (result === ID) { // Get the empApplnAddtnlInfoEntriesId if parameters id and Roundata detailsdto id matches..
					data = element[para].empApplnAddtnlInfoEntriesId
					break;
				}
			}
		}
		return data;
	}

	const formResearchDetails = () => {
		let ResearchDataList = [];
		if (RenderData !== null && RenderData.length > 0 && RenderData !== null) {
			RenderData.map((el) => {
				if (
					el.isTypeResearch === false &&
					el.employeeCategoryId === ActiveInterviewRound.empEmployeeCategoryId
				) {
					if (el.detailsDTO.length > 0) {
						let construct = {
							id: el.value,
							isTypeResearch: el.isTypeResearch,
							groupHeading: el.label,
							displayOrder: el.headingDisplayOrder,
							parameters: []
						};
						el.detailsDTO.map((item, index) => {
							if (item.isDisplayInApplication === true) {
								let innerObj = {
									id: item.value,
									empApplnAddtnlInfoEntriesId: savedAddnlInfoEntries(item.value),
									empApplnEntriesId:
										ActiveInterviewRound.empApplnEntriesId !== undefined
											? ActiveInterviewRound.empApplnEntriesId
											: null,
									displayOrder: item.parameterDisplayOrder,
									researchParameter: item.label,
									isDisplayInApplication: item.isDisplayInApplication,
									parameterValue:
										roundData.ResearchDetailsData[el.label] !== (undefined && null)
											? roundData.ResearchDetailsData[el.label][item.label]
											: null
								};
								return construct.parameters.push(innerObj);
							}
							return '';
						});
						return ResearchDataList.push(construct);
					}
				}
				return '';
			});
		}
		return ResearchDataList.length > 0 ? ResearchDataList : null;
	};

	const submitData = () => {
		var ApiData = {

			identityRow: ActiveInterviewRound.identityRow !== undefined ? ActiveInterviewRound.identityRow : null,

			empApplnEntriesId:
				ActiveInterviewRound.empApplnEntriesId !== undefined ? ActiveInterviewRound.empApplnEntriesId : null,
			applicationNo: ActiveInterviewRound.applicationNo !== undefined ? ActiveInterviewRound.applicationNo : null,
			empApplnInterviewSchedulesId:
				ActiveInterviewRound.empApplnInterviewSchedulesId !== undefined
					? ActiveInterviewRound.empApplnInterviewSchedulesId
					: null,
			interviewRound:
				ActiveInterviewRound.interviewRound !== undefined ? ActiveInterviewRound.interviewRound : null,
			isAvailableForTheInterview: roundData.availableForInt,
			empApplnNonAvailabilityDTO:
				roundData.availableForInt === 'true'
					? null
					: roundData.RejectionReason.label === 'Other'
						? {
							empApplnNonAvailabilityId: null,
							nonAvailabilityName: roundData.otherReason,
							isReschedulable: null,
							interviewRound:
								ActiveInterviewRound.interviewRound !== undefined
									? ActiveInterviewRound.interviewRound
									: null
						}
						: {
							empApplnNonAvailabilityId: roundData.RejectionReason.value,
							nonAvailabilityName: roundData.RejectionReason.label,
							isReschedulable: roundData.RejectionReason.isReschedulable,
							interviewRound: roundData.RejectionReason.interviewRound
						},
			researchDetailDTO: {
				researchEntries: {
					researchEntriesHeadings: formResearchDetails()
				}
			},
			empApplnPersonalDataDTO: {
				empApplnPersonalDataId:
					ActiveInterviewRound.empApplnPersonalDataId !== undefined
						? ActiveInterviewRound.empApplnPersonalDataId
						: null,
				empApplnEntriesId:
					ActiveInterviewRound.empApplnEntriesId !== undefined
						? ActiveInterviewRound.empApplnEntriesId
						: null,
				isUanNo: roundData.HaveUanNo,
				uanNo: roundData.UanNo
			}
		};
		setLoaderActive(true);
		let url = !isShowInterviewDetails() ? 'Employee/Recruitment/EmployeeApplicationControler/submitEmployeeApplicationInterviewDetails' :
			"Employee/Recruitment/EmployeeApplicationControler/submitEmployeResearchData";
		// let url = 'Employee/Recruitment/EmployeeApplicationControler/submitEmployeeApplicationInterviewDetails';
		ApiGateway.post(url, ApiData, (response) => {
			try {
				setLoaderActive(false);
				if (ERPUtils.isUndefinedOrNull(response) === false) {
					try {
						if (response.status === 'SUCCESS') {
							toast.success("Data Submitted Successfully")
							getApplicationsData();
						} else {
							setLoaderActive(false);
						}
					} catch (ex) { }
				}
			} catch (ex) {
				setLoaderActive(false);
			}
		});
	};

	React.useEffect(() => {
		if (interviewDetails.editable === false) {
			callAdditionalDataApi();
			ReasonsApi();
		}
		else if (isShowInterviewDetails()) {
			callAdditionalDataApi();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const isShowInterviewDetails = () => {
		if (!ERPUtils.isNullorWhiteSpace(savedData)) {
			if ((savedData.applicantWorkFlowStatusCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED"
				|| savedData.applicantWorkFlowStatusCode === "EMP_STAGE2_SELECTED" ||
				savedData.applicantWorkFlowStatusCode === "EMP_STAGE2_PO_RESCHEDULED") && (
					savedData.applicationWorkFlowStatusCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED"
					|| savedData.applicationWorkFlowStatusCode === "EMP_STAGE2_SELECTED" ||
					savedData.applicationWorkFlowStatusCode === "EMP_STAGE2_PO_RESCHEDULED")) {
				return true;
			}
			return false;
		}
		return false;
	}


	return (
		<div>
			<div style={{ height: "auto", overflow: "auto" }}>
				{isShowInterviewDetails() ? (
					<>
						<AdditionalInfoForm
							onChangeHandler={onChangeHandler}
							RenderData={RenderData}
							interviewDetails={interviewDetails}
							roundData={roundData}
							// newRoundedState={newRoundedState}
							ResearchDetailsHandler={ResearchDetailsHandler}
							ActiveInterviewRound={ActiveInterviewRound}
							RequiedFields={RequiedFields}

						/>
					</>
				) : (
					<>
						<InterviewScheduleDetails interviewDetails={interviewDetails} />

						<div className="parentBoxDiv border">
							<div className="childBoxDiv box sub">
								<div className="row" style={{ paddingLeft: '10px' }}>
									<div className="col-md-4 col-xs-12">
										<label className="formExpLabel">
											<span className="requiredText">*</span>
											Available for the interview
										</label>
									</div>
									<div className="col-md-5" style={{ top: '13px' }}>
										<label className="radio-inline">
											<input
												className="space"
												onChange={onChangeHandler}
												type="radio"
												name="availableForInt"
												value="true"
												checked={roundData.availableForInt === 'true'}
												disabled={interviewDetails.editable === false ? true : false}
											/>
											Yes
										</label>
										<label className="radio-inline">
											<input
												className="space"
												onChange={onChangeHandler}
												type="radio"
												name="availableForInt"
												value="false"
												checked={roundData.availableForInt === 'false'}
												disabled={interviewDetails.editable === false ? true : false}
											/>
											No
										</label>
										{RequiedFields.availableForIntReqError ? (
											<p className="RoundValidationError">
												<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
											</p>
										) : null}
									</div>
								</div>
							</div>
						</div>
						<div>
							{roundData.availableForInt === 'true' && isShowInterviewDetails() ? (
								<AdditionalInfoForm
									onChangeHandler={onChangeHandler}
									RenderData={RenderData}
									interviewDetails={interviewDetails}
									roundData={roundData}
									// newRoundedState={newRoundedState}
									ResearchDetailsHandler={ResearchDetailsHandler}
									ActiveInterviewRound={ActiveInterviewRound}
									RequiedFields={RequiedFields}

								/>
							) : null}

							{roundData.availableForInt === 'false' ? (
								<UnAvailableReasons
									selectHandler={selectHandler}
									ReasonsData={roundData.RejectionReason}
									ReasonsForRej={ReasonsForRej}
									otherReason={roundData.otherReason}
									onChangeHandler={onChangeHandler}
									RequiedFields={RequiedFields}
									interviewDetails={interviewDetails}
								/>
							) : null}
						</div>
					</>
				)}

			</div>

			{interviewDetails.editable === false ? null : (
				<div className="buttonsParentTab">
					<div className="row buttonsChildTab">
						<div className="col d-flex justify-content-center text-center pt-1 pb-2 ">
							<button
								className="myButton DashboardSubmitBtn z-depthButton"
								value="Previous"
								name="PersonalDetails"
								onClick={isShowInterviewDetails() ? submitData : CheckRequiredErrors}
							>
								Submit
							</button>
							<button
								className="myButton DashBoardCancel z-depthButton"
								name="cancel"
								onClick={closeInterviewModal}
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			)}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			{showAlert ? (
				<Popup
					open={showAlert}
					close={hideAlert}
					msg="We will reschedule the interview and update you the details accordingly."
					icon={<i className="fa fa-check successIcon" aria-hidden="true" />}
				/>
			) : null}
			{/* {warningMsg ? (
				<Popup
					open={warningMsg}
					close={warningHanlder}
					title="Warning!"
					msg="We will reschedule the interview and update you the details accordingly."
				// icon={<i className="fa fa-exclamation ConfirmWarningIcon" />}
				/>
			) : null} */}
			{ApiError ? (
				<Popup
					open={ApiError}
					close={closeErrorPopup}
					msg="Error! occourred while loading the data."
					title="Sorry! for the inconvenience occourred"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					hint="Note: Please try again."
					tabName=""
				/>
			) : null}
			{requiredFieldsAlert ? (
				<Popup
					open={requiredFieldsAlert}
					close={RequiredFieldsAlert}
					msg="Some of the Required fields are missing."
					title="Error!"
					icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
					success={false}
					tabName=""
				/>
			) : null}
		</div>

	);
};

export default SecondRound;
